var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"Ressources"}},[_c('Ressources')],1),_c('el-tab-pane',{attrs:{"label":"Import/Export"}},[_c('Importation')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }